'use strict';

module.exports = function (ngModule) {
    ngModule.directive('sevTable', require('./table'));
    ngModule.directive('tableSearchSidebar', require('./search_sidebar'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/table/index.js
 **/